import { erc20Abi } from 'viem'

import { getViemClient } from '@src/hooks/evm/useViemClient'
import { walletLogger } from '@src/utils/logger'

export const getEvmAllowance = async (
    address: `0x${string}`,
    owner: `0x${string}`,
    spender: `0x${string}`,
    chainId: number
): Promise<bigint> => {
    try {
        // Get the viem client for the specified chain
        const client = getViemClient(chainId)
        if (!client) {
            throw new Error(`No viem client available for chainId: ${chainId}`)
        }

        // Read the contract using viem client
        const result = await client.readContract({
            abi: erc20Abi,
            address,
            functionName: 'allowance',
            args: [owner, spender],
        })
        return BigInt(result)
    } catch (error) {
        walletLogger.error('Error checking EVM allowance:', { error })
        return BigInt(0)
    }
}
